import { SkillStatus } from '../../enums';
import { enumToList } from '../enum-to-list';
import { IdName } from '../../models';

export function getSkillStatus(skillStatus: SkillStatus): string {
  switch (skillStatus) {
    case SkillStatus.Completed:
      return 'Met Requirement';
    case SkillStatus.InCompleted:
      return 'Incomplete Requirement';
    case SkillStatus.OverCompleted:
      return 'Exceeded Requirement';
  }
}

export function getSkillStatusList(): IdName[] {
  return enumToList(SkillStatus, getSkillStatus);
}
